<template>
  <div id="School-edit">

      <IForm ref="formInline" :model="edit" :elem="classElem" :rules="classRule" :label-width="80" @on-submit="toSubmit" :submit="false" :showMessage="true">
        <div slot="extend">

          <Row>
            <Col span="24">
              <FormItem  label="学校名称"  prop="schoolId">
                <el-select v-model.trim="edit.schoolId" placeholder="学校名称"
                           clearable filterable size="small" transfer="true"
                           :popper-append-to-body="false" @change="changeSchool" style="width: 100%;">
                  <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"
                             @click.native="handleShoolChange(item)" style="width: 100%;z-index: 9999;"
                  />
                </el-select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem  label="年级"  prop="gradeId">
                <el-select v-model.trim="edit.gradeId" placeholder="年级"
                           clearable filterable size="small" transfer="true"
                           :popper-append-to-body="false" style="width: 100%;">
                  <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id"
                             @click.native="handleGradeChange(item)" style="width: 100%;"
                  />
                </el-select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="班级" prop="name">
                <Input v-model.trim="edit.name" type="text" placeholder="请输入班级名称" maxlength="50"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="联系人" prop="contactPerson"><Input v-model="edit.contactPerson" type="text" placeholder="请输入联系人" maxlength="50"/></FormItem></Col>
            <Col span="12"><FormItem label="联系电话" prop="telphone"><Input v-model="edit.telphone" type="text" placeholder="请输入联系电话" maxlength="50"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="状态" prop="status">
                <Select v-model="edit.status">
                  <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" prop="remark"><Input v-model="edit.remark" type="textarea" placeholder="请输入备注"/></FormItem>
            </Col>
          </Row>
        </div>
      </IForm>

  </div>
</template>
<script>
import {_get, _save} from "@/services/classes/class";
import {_schoolsList, _gradesList} from "@/services/studentManage/studentManage";
import {enums} from "@/services/enums";
export default {
  name: "ClassesEdit",
  data() {
    return {
      enums:enums,
      schoolList:[],
      gradeList:[],
      edit: {
        schoolId: "",
        gradeId: "",
        name: "",
        contactPerson: "",
        telphone: "",
        remark: "",
        status: 1
      },
      init: "",
      classElem: [],
      classRule: {
        schoolId: [
          {
            required: true,
            message: "请选择学校"
          }
        ],
        gradeId: [
          {
            required: true,
            message: "请选择年级",
            type:'number'
          }
        ],
        name: [
          {required: true, message: '班级名称不能为空', trigger: 'blur'},
          {maxlength:50,message:"班级名称长度不能超过50个字",trigger: 'blur'}
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type:'number'
          }
        ]
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
    if (this.$userSession.checkInstitutionId()) {
      this.getShoolName();
    }
  },
  methods: {
    handleShoolChange(item) {
      this.edit.schoolId = item.id.toString();
    },
    handleGradeChange(item) {
      this.edit.gradeId = item.id;
    },
    getShoolName(){
      _schoolsList().then(res=>{
        if (res.errcode === 1 && res.data) {
          this.schoolList = res.data;
        }
      });
    },
    changeSchool(schoolId, gradeId){
      if(!schoolId){
        return;
      }
      _gradesList({schoolId : schoolId}).then(res=>{
        this.edit.gradeId = "";
        if (res.errcode === 1 && res.data){
          this.gradeList = res.data;
          this.edit.gradeId = (gradeId ? gradeId : "");
        }else{
          this.gradeList =[]
        }
      })
    },
    handleModal(row) {
      this.$refs["formInline"].handleReset();

      this.gradeList = [];
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({id: row.id}).then(res =>{
        row = res.data;
        const edit = Object.assign({}, row);
        edit.schoolId = edit.schoolId.toString();
        this.changeSchool(edit.schoolId, edit.gradeId);
        this.edit = {
          ...edit,
        };
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      _save(this.edit).then(res => {
          if (res.errcode === 1) {
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
